import { connect } from 'react-redux'
import Input from '../../../Input'
import { getSelectedEstate } from '../../../../reducers/app'
import { useSize } from '../../../utils'

function Chains({ chains, onChange, userChains, value }) {
    const { isMobile } = useSize()
    const usableChains = chains
        .filter((chain) => userChains.includes(chain.id))
        .map(({ id, name }) => ({ name, value: id }))

    const handleOnchange = ({ target: { value } }) => {
        onChange(value)
    }

    return (
        <Input
            id="selectedChains"
            name="selectedChains"
            type="multiple"
            onChange={handleOnchange}
            value={value ? [value] : []}
            values={usableChains}
            column={isMobile}
            onlyOne
        />
    )
}

const mapStateToProps = (state) => {
    return {
        chains: state.chains.chains,
        userChains: getSelectedEstate(state).chains,
    }
}

export default connect(mapStateToProps)(Chains)
